<template>
    <div class="bg_blue">
        <div class="container_wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
                <el-breadcrumb-item :to="{ path: '/indexpc'}">首页</el-breadcrumb-item>
                <el-breadcrumb-item> 人才库申报</el-breadcrumb-item>
            </el-breadcrumb>
            <el-alert title="温馨提示" type="error" class="elalert">
                1.请先登陆个人会员帐号或注册（注意只对个人会员，单位会员无法报名）<br />
                2.请您确保在整个申报流程中，您所填写的信息属实。<br />
            </el-alert>

            <div class="left_and_right_container">
                <div class="container_list_item">
                    <div class="item_title">演员公会</div>
                    <div class="item_but_up">
                        <el-button type="primary" @click="goApply(1)" round plain>开始申报</el-button>
                    </div>
                    <div class="item_but_down">
                        <el-button type="primary" round @click="dialogVisible = true ; type='1'"
                        >电子协议</el-button
                        >
                    </div>
                </div>
                <!-- <div class="container_list_item">
                    <div class="item_title">童星库</div>
                    <div class="item_but_up">
                        <el-button type="primary" @click="goApply(2)"  round plain>开始申报</el-button>
                    </div>
                    <div class="item_but_down">
                        <el-button type="primary" round @click="dialogVisible = true ; type='2'"
                        >电子协议</el-button
                        >
                    </div>
                </div> -->
                <div class="container_list_item">
                    <div class="item_title">艺术导师（评委）库</div>
                    <div class="item_but_up">
                        <el-button type="primary"  @click="goApply(3)"  round plain>开始申报</el-button>
                    </div>
                    <div class="item_but_down">
                        <el-button type="primary" round @click="dialogVisible = true ; type='3'"
                        >电子协议</el-button
                        >
                    </div>
                </div>
                <div class="container_list_item">
                    <div class="item_title">专业人才库</div>
                    <div class="item_but_up">
                        <el-button type="primary"  @click="goApply(4)"  round plain>开始申报</el-button>
                    </div>
                    <div class="item_but_down">
                        <el-button type="primary" round @click="dialogVisible = true ; type='4'"
                        >电子协议</el-button
                        >
                    </div>
                </div>
            </div>

            <el-dialog title="电子协议" :visible.sync="dialogVisible">
                 <div>
                     电子协议内容。。。。
                 </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">关闭</el-button>
                  <el-button type="primary" @click="goApply()"
                  >立即报名</el-button
                  >
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import NewsListItem from "@/components/listItem/NewsListItem";
    import { CountDown } from "vant";

    Vue.use(CountDown);

    export default {
        name: "CmsDetail",
        data() {
            return {
                dialogVisible: false,
                activeName: "1",
                type:'',
                row: {
                    id: 0,
                    current_index: 0,
                    user: {},
                    kaoji: {},
                },
            };
        },
        components: {
            NewsListItem,
        },
        computed: {},
        mounted() {
            let that = this;
        },
        methods: {
            goApply(type){
                let that  = this;
                if(type){
                    this.type = type;
                }
                this.$router.push({name:'RencaikuApplyStep'+(that.type)+'1'});
            }
        },
    };
</script>
<style scoped lang="scss">
    .status-1 {
        background: #559f07;
        color: #fff;
    }
    .status-2 {
        background: #e02020;
        color: #fff;
    }
    .status-0 {
        background: #f4faff;
        color: #666666;
    }
    .bg_blue {
        width: 100%;
        background: #f4faff;
        height: 100%;
        overflow: hidden;
    }
    .container_wrap {
        width: 1240px;
        margin: 0 auto;
        min-height: 1235px;
    }
    .breadcrumb {
        margin-top: 21px;
        margin-left: 23px;
        margin: 21px 0 20px 23px;
    }
    .elalert {
        margin: 0 0 40px 0;
    }
    .left_and_right_container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .container_list_item {
            width: 290px;
            height: 460px;
            padding-top: 40px;
            box-sizing: border-box;
            overflow: hidden;
            background: #fdfdfd;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 68px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;
            .item_pic {
                width: 92px;
                height: 106px;
                background: url("~@/assets/images/listitem/编组 4@2x.png") no-repeat
                center center;
                background-size: 100% 100%;
            }
            .item_title {
                height: 25px;
                font-size: 18px;
                font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                font-weight: 500;
                color: #333333;
                line-height: 25px;
                margin: 24px 0 0 0;
            }
            .item_but_up {
                margin: 40px 0 24px 0;

                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #d3ebff;
                    width: 229px;
                    height: 44px;
                    color: #333333;
                    border: none;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            .item_but_down {
                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #0091ff;
                    width: 229px;
                    height: 44px;
                    border: none;
                    border-radius: 22px;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            &:nth-child(2) {
                .item_pic {
                    background: url("~@/assets/images/listitem/形状@2x.png") no-repeat
                    center center;
                    background-size: 100% 100%;
                }
                .item_but_up {
                    margin: 40px 0 24px 0;
                    /deep/.el-button {
                        background: #ffc79f;
                    }
                }
                .item_but_down {
                    /deep/.el-button {
                        background: #fa6400;
                    }
                }
            }
        }

        // .container_left {
        //   width: 212px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
        // .container_center {
        //   width: 716px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }

        // .container_right {
        //   width: 296px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
    }
</style>


// WEBPACK FOOTER //
// RencaikuApplyIndex.vue?1bdd14d3